/**
 * Use real <a href> for SPA routes so Ctrl/Cmd+click and "Open in new tab" work.
 */
export function isModifiedNavigationEvent(event) {
  return Boolean(
    event.metaKey
    || event.ctrlKey
    || event.shiftKey
    || event.altKey
    || event.button === 1
  );
}

export function handleSpaNavClick(event, navigate, path) {
  if (isModifiedNavigationEvent(event)) return;
  event.preventDefault();
  navigate(path);
}
